import React from 'react'
import { IBreadcrumbSecondaryItem } from '../../common/BreadcrumbSecondaryItem'
import BreadcrumbsSecondary from '../../common/BreadcrumbsSecondary'

const FindMyAwardBreadcrumbs = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const items: IBreadcrumbSecondaryItem[] = [
    {
      name: 'Home',
      url: govCMSHome,
      index: 1,
    },
    {
      name: 'Employment conditions',
      url: govCMSHome + '/employment-conditions',
      index: 2,
    },
    {
      name: 'Awards',
      url: govCMSHome + '/employment-conditions/awards',
      index: 3,
    },
  ]
  return (
    <>
      <BreadcrumbsSecondary items={items} />
    </>
  )
}

export default FindMyAwardBreadcrumbs
